export const capitalizeEachWord = (string: string): string => {
	return string.replace(/^(.)|\s+(.)/g, (c) => c.toUpperCase())
}

export const capitalizeFirstWord = (string: string): string => {
	return string.charAt(0).toUpperCase() + string.slice(1)
}
